import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const ConsentBanner = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const consentGiven = localStorage.getItem('cookieConsent');
    if (!consentGiven) {
      setIsVisible(true);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem('cookieConsent', 'all');
    setIsVisible(false);
  };

  const handleEssentialOnly = () => {
    localStorage.setItem('cookieConsent', 'essential');
    setIsVisible(false);
  };

  const handleDecline = () => {
    window.location.href = 'https://www.educaloi.qc.ca/';
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white shadow-lg z-50 border-t border-gray-200">
      <div className="max-w-7xl mx-auto p-4">
        {!expanded ? (
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-gray-700 font-medium">
              {t('consentBanner.shortMessage', 'Ce site utilise des cookies pour améliorer votre expérience.')}
            </p>
            <div className="flex items-center gap-3">
              <button 
                onClick={() => setExpanded(true)}
                className="text-sm text-gray-600 underline hover:text-gray-900"
              >
                {t('consentBanner.moreInfo', 'Plus d\'informations')}
              </button>
              <button 
                onClick={handleEssentialOnly}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 transition-colors"
              >
                {t('consentBanner.essentialOnly', 'Cookies essentiels')}
              </button>
              <button 
                onClick={handleAcceptAll}
                className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 transition-colors"
              >
                {t('consentBanner.acceptAll', 'Tout accepter')}
              </button>
            </div>
          </div>
        ) : (
          <div className="space-y-4">
            <div className="flex justify-between items-center">
              <h3 className="text-base font-semibold text-gray-900">
                {t('consentBanner.title', 'Paramètres de confidentialité')}
              </h3>
              <button 
                onClick={() => setExpanded(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </button>
            </div>
            
            <p className="text-sm text-gray-700">
              {t('consentBanner.complianceMessage', 'Conformément à la Loi 25, nous vous informons de l\'utilisation de cookies sur notre site. Certains cookies sont nécessaires au fonctionnement du site, tandis que d\'autres nous aident à l\'améliorer et à personnaliser votre expérience.')}
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="bg-gray-50 rounded p-3">
                <h4 className="font-medium text-sm mb-1">{t('consentBanner.essentialCookies', 'Cookies essentiels')}</h4>
                <p className="text-xs text-gray-600">{t('consentBanner.essentialDescription', 'Nécessaires au fonctionnement du site. Ils ne peuvent pas être désactivés.')}</p>
              </div>
              <div className="bg-gray-50 rounded p-3">
                <h4 className="font-medium text-sm mb-1">{t('consentBanner.nonEssentialCookies', 'Cookies facultatifs')}</h4>
                <p className="text-xs text-gray-600">{t('consentBanner.nonEssentialDescription', 'Utilisés pour l\'analyse et l\'amélioration de votre expérience.')}</p>
              </div>
            </div>
            
            <p className="text-xs text-gray-600">
              {t('consentBanner.moreInfo', 'Pour plus d\'informations, consultez notre')}{' '}
              <Link to="/privacy-policy" className="text-blue-600 hover:underline">
                {t('consentBanner.policyLink', 'politique de confidentialité')}
              </Link>.
            </p>
            
            <div className="flex justify-end space-x-3">
              <button 
                onClick={handleDecline}
                className="px-4 py-2 text-sm font-medium text-gray-700 rounded-md hover:bg-gray-100 transition-colors"
              >
                {t('consentBanner.decline', 'Quitter')}
              </button>
              <button 
                onClick={handleEssentialOnly}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 transition-colors"
              >
                {t('consentBanner.essentialOnly', 'Cookies essentiels uniquement')}
              </button>
              <button 
                onClick={handleAcceptAll}
                className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 transition-colors"
              >
                {t('consentBanner.acceptAll', 'Accepter tous les cookies')}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ConsentBanner; 